import React, { useEffect, useState } from "react";
import { getSuggest } from "../../services/API/axios";
import "./SearchResult.css";
import SongLyrics from "../SongLyrics/SongLyrics";
import ReactPaginate from "react-paginate";
import AlbumIcon from "@material-ui/icons/Album";
import PersonIcon from "@material-ui/icons/Person";
import BeatLoader from "react-spinners/BeatLoader";
import logo from "../../assets/Dog-swimming.png";
import defaultImage from "../../assets/hero-background.jpg";

function SearchResult({ musicType }) {
  console.log("music type in search result", musicType);
  const PER_PAGE = 7;
  const [loading, setLoading] = useState(true);
  const [searchResult, setSearchResult] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const [music, SetMusic] = useState({
    artist: "",
    title: "",
    albumTitle: "",
    picture: "",
  });
  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      const request = await getSuggest.get(musicType);
      setSearchResult(request.data.data);
      setLoading(false);
      return request;
    }
    fetchData();
  }, [musicType]);

  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }
  const offset = currentPage * PER_PAGE;

  const currentPageData = searchResult
    .slice(offset, offset + PER_PAGE)
    .map((Element, i) => (
      <div
        className="search__row__card"
        onClick={() => getLyrics(Element)}
        tabIndex={0}
        key={Element.id}
      >
        <img src={Element.artist.picture_medium} alt={defaultImage} />
        <div className="search__row__album__title">
          <PersonIcon />
          <label>{Element.artist.name}</label>
        </div>
        <div className="search__row__album__title">
          <AlbumIcon />
          <label>{Element.album.title}</label>
        </div>
      </div>
    ));

  const pageCount = Math.ceil(searchResult.length / PER_PAGE);

  function getLyrics(event) {
    SetMusic({
      artist: event.artist.name,
      title: event.title,
      albumTitle: event.album.title,
      picture: event.artist.picture_medium,
    });
  }
  return (
    <div>
      <label className="search__label"> Search Result</label>

      <label className="search__musictype"> : {musicType}</label>
      <div>
        {!loading && searchResult.length == 0 ? (
          <h1>No data available</h1>
        ) : !loading && searchResult.length > 0 ? (
          <>
            <div className="search__row">
              <div className="search__current__page">{currentPageData}</div>
            </div>
            <div className="search__paginate">
              <ReactPaginate
                previousLabel={"←"}
                nextLabel={"→"}
                pageCount={pageCount}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                previousLinkClassName={"pagination__link"}
                nextLinkClassName={"pagination__link"}
                disabledClassName={"pagination__link--disabled"}
                activeClassName={"pagination__link--active"}
              />
            </div>
          </>
        ) : (
          <BeatLoader loading="true" color={"#ffffff"} />
        )}
      </div>
      {music.artist && <SongLyrics music={music} />}
    </div>
  );
}

export default SearchResult;
